import React, { useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from 'oidc-react'
import getEnv from '../lib/get-env.js'
import { saveTokenCookie } from '../lib/save-token-cookie.js'

const cookieName = getEnv('REACT_APP_TOKEN_COOKIE_NAME')

function RefreshToken() {
  const { userManager } = useAuth()
  const hasRefreshedTokenRef = useRef(false)

  // Extract returnUrl from query parameters and store in localStorage
  const params = new URLSearchParams(useLocation().search)
  const returnUrl =
    params.get('returnUrl') || params.get('returnTo') || params.get('callback')

  useEffect(() => {
    if (hasRefreshedTokenRef.current) {
      return
    }

    async function refreshToken() {
      const isInIframe = window.self !== window.top
      let refreshSuccess = false

      // try to refresh the token
      try {
        // When refresh token is present, this will refresh the token and return the user
        // When refresh token is not present, this will try iframe silent signin and return the user
        // If the silentRedirectUri is not configured, this will throw an error and not wait for the timeout
        // prompt none is used to get an error if the login is required instead of iframe hanging and waiting for timeout
        const user = await userManager.signinSilent({
          extraQueryParams: { prompt: 'none' },
        })
        if (user) {
          // user is already signed in, or token was refreshed, no need to sign in again
          await saveTokenCookie({ cookieName: cookieName, userData: user })
          refreshSuccess = true
        }
      } catch (error) {
        console.log('error', error)
      }

      if (isInIframe) {
        const parentMessage = refreshSuccess
          ? {
              type: 'TOKEN_REFRESHED',
            }
          : {
              type: 'TOKEN_REFRESH_FAILED',
            }

        window.parent.postMessage(parentMessage, '*')
        return
      }

      // if not in iframe, redirect back or to sign in
      const newLocation = refreshSuccess
        ? returnUrl || getEnv('REACT_APP_DEFAULT_RETURN_URL') || '/'
        : `/signin${returnUrl ? `?returnUrl=${returnUrl}` : ''}`
      window.location.href = newLocation
    }

    refreshToken()
    hasRefreshedTokenRef.current = true
  }, [userManager])

  return (
    <div>
      <p>Refreshing tokens...</p>
    </div>
  )
}

export default RefreshToken
